var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCsv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "CSV",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #CSV .cls-1 {\n        fill: #ff7600;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1317.411 -344.125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_583",
    "data-name": "Pfad 583",
    className: "cls-1",
    d: "M1337.411,384.125a20,20,0,1,1,20-20A20.023,20.023,0,0,1,1337.411,384.125Zm0-37.849a17.849,17.849,0,1,0,17.849,17.849A17.87,17.87,0,0,0,1337.411,346.276Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_584",
    "data-name": "Pfad 584",
    className: "cls-1",
    d: "M1337.319,379.2l2.008,2.159,2.008-2.159h.068v-.073l6.068-6.525-1.458-1.358L1341.4,376.2V364.849h-4.148v11.357l-4.611-4.962-1.458,1.358,6.07,6.529v.069Z",
    transform: "translate(-1.926 -2.897)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_585",
    "data-name": "Pfad 585",
    className: "cls-1",
    d: "M1333.4,358.126h1.622c0,.039,0,.1.006.171s.006.135.006.177a3.444,3.444,0,0,1-.655,2.305,2.511,2.511,0,0,1-2,.753,3.258,3.258,0,0,1-1.1-.165,2.03,2.03,0,0,1-.791-.514,2.633,2.633,0,0,1-.639-1.279,14.635,14.635,0,0,1-.187-2.838,17.153,17.153,0,0,1,.111-2.2,3.415,3.415,0,0,1,.343-1.218,2.235,2.235,0,0,1,.9-.892,2.966,2.966,0,0,1,1.366-.276,2.5,2.5,0,0,1,1.979.709,3.451,3.451,0,0,1,.625,2.28h-1.616v-.215a1.993,1.993,0,0,0-.236-1.085.8.8,0,0,0-.718-.358.811.811,0,0,0-.816.495,9.555,9.555,0,0,0-.219,2.733,11.3,11.3,0,0,0,.212,2.941.8.8,0,0,0,.811.524.81.81,0,0,0,.779-.41,3.55,3.55,0,0,0,.22-1.514Z",
    transform: "translate(-1.713 -1.122)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_586",
    "data-name": "Pfad 586",
    className: "cls-1",
    d: "M1337.511,358.172h1.669v.575a2.14,2.14,0,0,0,.206,1.125.8.8,0,0,0,.712.3,1.114,1.114,0,0,0,.805-.268,1.052,1.052,0,0,0,.276-.791,1.211,1.211,0,0,0-.192-.689,3.439,3.439,0,0,0-.832-.742l-.854-.6a5.078,5.078,0,0,1-1.4-1.267,2.412,2.412,0,0,1-.3-1.256,2.331,2.331,0,0,1,.668-1.768,3,3,0,0,1,3.75.04,2.687,2.687,0,0,1,.663,1.954c0,.085,0,.151,0,.2s0,.088-.009.122h-1.581v-.238a1.751,1.751,0,0,0-.238-1.041.925.925,0,0,0-.785-.314.838.838,0,0,0-.631.236.9.9,0,0,0-.23.654q0,.564,1.029,1.25a.079.079,0,0,1,.018.012l.919.622a4.318,4.318,0,0,1,1.331,1.23,2.811,2.811,0,0,1,.349,1.474,2.478,2.478,0,0,1-.7,1.884,2.784,2.784,0,0,1-1.995.662,2.642,2.642,0,0,1-2.009-.7,3,3,0,0,1-.66-2.127c0-.1.008-.268.023-.5Z",
    transform: "translate(-2.807 -1.122)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_587",
    "data-name": "Pfad 587",
    className: "cls-1",
    d: "M1346.6,361.352l-2.011-8.953h1.785l1.331,7.145,1.2-7.145h1.762l-1.878,8.953Z",
    transform: "translate(-3.799 -1.157)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsv);
export default __webpack_public_path__ + "static/media/csv.3ad800b62a5895038e0d4a6f9cbc6fbc.svg";
export { ForwardRef as ReactComponent };